import { render, staticRenderFns } from "./SidebarAlphaImgSetting.vue?vue&type=template&id=defb6898&"
import script from "./SidebarAlphaImgSetting.vue?vue&type=script&lang=js&"
export * from "./SidebarAlphaImgSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports